module.exports = __webpack_public_path__ + "img/heating-control-sm.a735e41f.svg";